import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import api from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Meta from "../../components/Meta";
import { useHistory } from "react-router-dom";

function StepFour({ prevStep, values }) {
  // eslint-disable-next-line
  const [error, setError] = useState(false);
  const [imgPerfil, setImgPerfil] = useState("");
  const [imgComprovante, setImgComprovante] = useState("");
  const [imgFrente, setImgFrente] = useState("");
  const [imgVerso, setImgVerso] = useState("");
  const [imgCpf, setImgCpf] = useState("");
  const [imgContrato, setImgContrato] = useState("");
  const [imgCtps, setImgCtps] = useState("");
  const [imgHolerite, setImgHolerite] = useState("");
  // eslint-disable-next-line
  const [dados, setDados] = useState(""); 

  const history = useHistory();

  const {
    nome,
    cpf,
    email,
    nomeSocial,
    dtNascimento,
    sexo,
    estadoCivil,
    dependente,
    tipoDoc,
    docIdentificacao,
    orgEmissor,
    dtEmissao,
    escolaridade,
    ultimaSerie,
    estudante,
    deficiente,
    nomePai,
    nomeMae,
    naturalidade,
    nacionalidade,
    fone1,
    fone2,
    renda,
    rendaFamiliar,
    estado,
    cidade,
    bairro,
    logradouro,
    cep,
    numero,
    cnpj,
    razaoSocial,
    contato,
    ctps,
    serie,
    situacao,
    pis_pasep,
    cargo,
    dtAdmissao,
    dtDemissao,
  } = values;

  const submitFormData = async (e) => {
    try {
      e.preventDefault();
      // Create an object of formData
      const formData = new FormData();

      // //Dados do FILES
      formData.append("docPerfil", imgPerfil);
      formData.append("docComprovante", imgComprovante);
      formData.append("docContrato", imgContrato);
      formData.append("docCpf", imgCpf);
      formData.append("docFrente", imgFrente);
      formData.append("docVerso", imgVerso);
      formData.append("docCtps", imgCtps);
      formData.append("docHolerite", imgHolerite);

      //Dados do FORM
      formData.append("email", email);
      formData.append("nome", nome);
      formData.append("cpf", cpf);
      formData.append("nomeSocial", nomeSocial);
      formData.append("dtNascimento", dtNascimento);
      formData.append("sexo", sexo);
      formData.append("estadoCivil", estadoCivil);
      formData.append("dependente", dependente);
      formData.append("tipoDoc", tipoDoc);
      formData.append("docIdentificacao", docIdentificacao);
      formData.append("orgEmissor", orgEmissor);
      formData.append("dtEmissao", dtEmissao);
      formData.append("escolaridade", escolaridade);
      formData.append("ultimaSerie", ultimaSerie);
      formData.append("estudante", estudante);
      formData.append("deficiente", deficiente);
      formData.append("nomePai", nomePai);
      formData.append("nomeMae", nomeMae);
      formData.append("naturalidade", naturalidade);
      formData.append("nacionalidade", nacionalidade);
      formData.append("fone1", fone1);
      formData.append("fone2", fone2);
      formData.append("renda", renda);
      formData.append("rendafamiliar", rendaFamiliar);
      formData.append("estado", estado);
      formData.append("cidade", cidade);
      formData.append("bairro", bairro);
      formData.append("logradouro", logradouro);
      formData.append("cep", cep);
      formData.append("numero", numero);
      formData.append("cnpj", cnpj);
      formData.append("razaoSocial", razaoSocial);
      formData.append("contato", contato);
      formData.append("ctps", ctps);
      formData.append("serie", serie);
      formData.append("situacao", situacao);
      formData.append("pis_pasep", pis_pasep);
      formData.append("cargo", cargo);
      formData.append("dtAdmissao", dtAdmissao);
      formData.append("dtDemissao", dtDemissao);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await api.put("/api/users/userdx", formData, config);
      setDados(data);
      history.push("/");
      

    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err);
    }
  };

  return (
    <>
      <ToastContainer />
      <Meta />
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">
                  <div className="text-center">
                    <h5 className="h5 text-gray-900 mb-4">
                      CADASTRO CLIENTE <br />
                      <small style={{ fontSize: "14px" }}>
                        Trabalhador do Comércio
                      </small>
                    </h5>
                    <br />

                    <div className="card card-timeline px-1 border-none mb-5">
                      <ul className="bs4-order-tracking">
                        <li className="step active">
                          <div>
                            <i className="fas fa-user"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}>pessoal </label>
                        </li>
                        <li className="step active">
                          <div>
                            <i className="far fa-envelope-open"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}> endereço</label>
                        </li>
                        <li className="step active">
                          <div>
                            <i className="far fa-address-card"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}>
                            profissional
                          </label>
                        </li>
                        <li className="step active">
                          <div>
                            <i className="fas fa-file-upload"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}>
                            documentação
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* formulario de cadastro  */}
                  <br />

                  <form className="user" onSubmit={submitFormData}>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>FOTO 3X4</label>

                        <input
                          style={{ border: error ? "2px solid red" : "" }}
                          type="file"
                          className="form-control-file"
                          id="file"
                          name="docPerfil"
                          onChange={(e) => {
                            setImgPerfil(e.target.files[0]);
                          }}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                        />
                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                        <p
                          className="text-dark mb-0"
                          style={{ fontSize: "11px" }}
                        >
                          A imagem deve estar na posição <b>retrato</b> e a
                          pessoa deve estar sozinha na foto. Na foto a pessoa
                          não deve usar acessórios tais como: óculos, boné,
                          chapéu ou qualquer outro que dificulte a
                          indentificação.
                          Tamanho máximo 5MB
                        </p>
                      </div>
                      <div className="col-sm-6">
                        <label>COMPROVANTE DE RESIDÊNCIA</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docComprovante"
                          id="file"
                          onChange={(e) => {
                            setImgComprovante(e.target.files[0]);
                          }}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.PDF,.pdf"
                        />
                        <p
                          className="text-dark mb-0"
                          style={{ fontSize: "11px" }}
                        >
                          Será aceito somente comprovante dos últimos{" "}
                          <b>3 meses</b> considerando a data atual.
                          Tamanho máximo 5MB
                        </p>
                      </div>
                    </div>

                    <hr className="mt-4 mb-5" />

                    <div className="form-group row">
                      <div className="form-group col-sm-6">
                        <label>CPF</label>
                        <input
                          type="file"
                          className="form-control-file"
                          name="docCpf"
                          id="file"
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                          onChange={(e) => {
                            setImgCpf(e.target.files[0]);
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>DOCUMENTO DE IDENTIFICAÇÃO - FRENTE</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docFrente"
                          id="docFrente"
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF,.pdf,.PDF"
                          onChange={(e) => {
                            setImgFrente(e.target.files[0]);
                          }}
                        />
                      </div>
                      <div className="col-sm-6">
                        <label>DOCUMENTO DE IDENTIFICAÇÃO - VERSO</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docVerso"
                          id="file"
                           accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF,.pdf,.PDF"
                          onChange={(e) => {
                            setImgVerso(e.target.files[0]);
                          }}
                        />
                      </div>
                    </div>

                    <hr className="mt-4 mb-5" />

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>CONTRATO DE TRABALHO </label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docContrato"
                          id="file"
                           accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF,.pdf,.PDF"
                          onChange={(e) => {
                            setImgContrato(e.target.files[0]);
                          }}
                        />
                        <p className="text-dark" style={{ fontSize: "11px" }}>
                          Página que contém as informações da Empresa.
                        </p>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>CARTEIRA DE TRABALHO </label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docCtps"
                          id="file"
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF,.pdf,.PDF"
                          onChange={(e) => {
                            setImgCtps(e.target.files[0]);
                          }}
                        />
                        <p className="text-dark" style={{ fontSize: "11px" }}>
                          Página assinada pela Empresa com as seguintes
                          informações:
                          <b>Razão Social (Nome da empresa)</b>, <b>CNPJ</b>,
                          <b> Cargo</b>, <b>Data de Admissão</b> e
                          <b>Renda (Salário)</b>.
                          Tamanho máximo 5MB
                        </p>
                      </div>
                      <div className="col-sm-6">
                        <label>CONTRA-CHEQUE </label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docHolerite"
                          id="file"
                           accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF,.pdf,.PDF"
                          onChange={(e) => {
                            setImgHolerite(e.target.files[0]);
                          }}
                        />
                        <p className="text-dark" style={{ fontSize: "11px" }}>
                          Contracheque mais recente emitido pela empresa que
                          contenham os dados da empresa e do funcionário.
                          Tamanho máximo 5MB
                        </p>
                      </div>
                    </div>

                    <hr className="mt-4" />

                    <Button
                      onClick={prevStep}
                      className="btn btn-primary btn-user btn-block bg-warning"
                    >
                      Anterior
                    </Button>

                    <Button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                    >
                      Continuar
                    </Button>
                  </form>

                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepFour;
